import { Component, HostBinding, Input } from '@angular/core';
import { environment } from '@env';
import { DashboardService } from '@v3/dashboard/dashboard.service';

@Component({
    selector: 'ms-dashboard-sidebar-logo',
    templateUrl: './dashboard-sidebar-logo.component.html',
    styleUrls: ['./dashboard-sidebar-logo.component.scss'],
    standalone: false
})
export class DashboardSidebarLogoComponent {
  @HostBinding('class')
  @Input()
    color: 'purple' | 'yellow' = 'purple';

  @HostBinding('class.shrink')
  get isShrink() {
    return this._dashboardService.isShrink;
  }

  get version() {
    return environment.version;
  }

  constructor(private readonly _dashboardService: DashboardService) {}

  toggleSidebar() {
    this._dashboardService.toggleExpander();
  }
}
